import type { ReactNode } from 'react';

// The editable copy tools stay in the design source; deployed copy is immutable.
export function Copy({ children }: { id: string; children: ReactNode }) {
  return <span>{children}</span>;
}
